"use client";

import { useTranslations } from "use-intl";

import { SearchUnavailableIcon } from "@/components/appIcons";

export function SearchEmptyPlaceholder({ show, query }: { show: boolean; query: string }) {
  const t = useTranslations("globals.search");
  if (!show) return null;
  return (
    <div className="text-center py-20">
      <SearchUnavailableIcon className="text-6xl text-muted-foreground mb-4" />
      <p className="text-xl font-medium">
        {query ? t("noResults", { query }) : t("noResultsFilters")}
      </p>
      <p className="text-muted-foreground mt-2">{t("tryDifferent")}</p>
    </div>
  );
}
